export const gridSettings = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 12,
  xl: 12,
};


